import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

import {
    SelectionBarDefault,
    SelectionBarMarginTopDefault,
    SelectionBarMarginTopWide,
    SelectionBarWide,
} from './Constants';

export const useSelectionBarStyles = makeStyles({
    root: {
        position: 'absolute',
        marginLeft: '2px',
        width: '2px',
        alignSelf: 'flex-start',
        height: SelectionBarDefault,
        marginTop: `${SelectionBarMarginTopDefault}px`,
        zIndex: 0,
        ...shorthands.borderRadius(tokens.borderRadiusXLarge),
        '@media (forced-colors: active)': {
            width: '0px',
        },
    },
    defaultColor: {
        backgroundColor: tokens.colorNeutralForeground3BrandSelected,
        '@media (forced-colors: active)': {
            ...shorthands.border(
                '1px',
                'solid',
                tokens.colorNeutralForeground3BrandSelected,
            ),
        },
    },
    animated: {
        top: 0,
        transitionDuration: '.26s',
        transitionProperty: 'all',
        msTransitionTimingFunction: 'cubic-bezier(.78,0,.22,1)',
    },
    wide: {
        marginTop: `${SelectionBarMarginTopWide}px`,
        height: SelectionBarWide,
    },
    hidden: {
        visibility: 'hidden',
    },
    visible: {
        visibility: 'visible',
    },
    anchored: {
        position: 'fixed',
        zIndex: 1,
    },
});
